/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPaymentMonthlyStatsData } from './SubscriptionPaymentMonthlyStatsData';
import {
    SubscriptionPaymentMonthlyStatsDataFromJSON,
    SubscriptionPaymentMonthlyStatsDataFromJSONTyped,
    SubscriptionPaymentMonthlyStatsDataToJSON,
    SubscriptionPaymentMonthlyStatsDataToJSONTyped,
} from './SubscriptionPaymentMonthlyStatsData';

/**
 * 
 * @export
 * @interface SubscriptionPaymentFinancialStatsData
 */
export interface SubscriptionPaymentFinancialStatsData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    currencyCode?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    currentMonthInvoicedNetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    currentMonthPendingNetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    previousMonthInvoicedNetAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    currentMonthMissingHistoricalInvoiceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    previousMonthMissingHistoricalInvoiceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    currentMonthNonAuthoritativeLedgerCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    previousMonthNonAuthoritativeLedgerCount?: number;
    /**
     * Number of source amounts excluded because their CZK conversion is unavailable.
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    missingCzkConversionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    monthOverMonthChangePercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    monthlyRecurringNetAmount?: number;
    /**
     * True when all source currencies are represented in CZK using CNB conversion snapshots.
     * @type {boolean}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    allCurrenciesConvertedToCzk?: boolean;
    /**
     * 
     * @type {Array<SubscriptionPaymentMonthlyStatsData>}
     * @memberof SubscriptionPaymentFinancialStatsData
     */
    monthlyNetAmounts?: Array<SubscriptionPaymentMonthlyStatsData>;
}

/**
 * Check if a given object implements the SubscriptionPaymentFinancialStatsData interface.
 */
export function instanceOfSubscriptionPaymentFinancialStatsData(value: object): value is SubscriptionPaymentFinancialStatsData {
    return true;
}

export function SubscriptionPaymentFinancialStatsDataFromJSON(json: any): SubscriptionPaymentFinancialStatsData {
    return SubscriptionPaymentFinancialStatsDataFromJSONTyped(json, false);
}

export function SubscriptionPaymentFinancialStatsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentFinancialStatsData {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'currentMonthInvoicedNetAmount': json['currentMonthInvoicedNetAmount'] == null ? undefined : json['currentMonthInvoicedNetAmount'],
        'currentMonthPendingNetAmount': json['currentMonthPendingNetAmount'] == null ? undefined : json['currentMonthPendingNetAmount'],
        'previousMonthInvoicedNetAmount': json['previousMonthInvoicedNetAmount'] == null ? undefined : json['previousMonthInvoicedNetAmount'],
        'currentMonthMissingHistoricalInvoiceCount': json['currentMonthMissingHistoricalInvoiceCount'] == null ? undefined : json['currentMonthMissingHistoricalInvoiceCount'],
        'previousMonthMissingHistoricalInvoiceCount': json['previousMonthMissingHistoricalInvoiceCount'] == null ? undefined : json['previousMonthMissingHistoricalInvoiceCount'],
        'currentMonthNonAuthoritativeLedgerCount': json['currentMonthNonAuthoritativeLedgerCount'] == null ? undefined : json['currentMonthNonAuthoritativeLedgerCount'],
        'previousMonthNonAuthoritativeLedgerCount': json['previousMonthNonAuthoritativeLedgerCount'] == null ? undefined : json['previousMonthNonAuthoritativeLedgerCount'],
        'missingCzkConversionCount': json['missingCzkConversionCount'] == null ? undefined : json['missingCzkConversionCount'],
        'monthOverMonthChangePercentage': json['monthOverMonthChangePercentage'] === undefined ? undefined : json['monthOverMonthChangePercentage'] === null ? null : json['monthOverMonthChangePercentage'],
        'monthlyRecurringNetAmount': json['monthlyRecurringNetAmount'] == null ? undefined : json['monthlyRecurringNetAmount'],
        'allCurrenciesConvertedToCzk': json['allCurrenciesConvertedToCzk'] == null ? undefined : json['allCurrenciesConvertedToCzk'],
        'monthlyNetAmounts': json['monthlyNetAmounts'] == null ? undefined : ((json['monthlyNetAmounts'] as Array<any>).map(SubscriptionPaymentMonthlyStatsDataFromJSON)),
    };
}

export function SubscriptionPaymentFinancialStatsDataToJSON(json: any): SubscriptionPaymentFinancialStatsData {
    return SubscriptionPaymentFinancialStatsDataToJSONTyped(json, false);
}

export function SubscriptionPaymentFinancialStatsDataToJSONTyped(value?: SubscriptionPaymentFinancialStatsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyCode': value['currencyCode'],
        'currentMonthInvoicedNetAmount': value['currentMonthInvoicedNetAmount'],
        'currentMonthPendingNetAmount': value['currentMonthPendingNetAmount'],
        'previousMonthInvoicedNetAmount': value['previousMonthInvoicedNetAmount'],
        'currentMonthMissingHistoricalInvoiceCount': value['currentMonthMissingHistoricalInvoiceCount'],
        'previousMonthMissingHistoricalInvoiceCount': value['previousMonthMissingHistoricalInvoiceCount'],
        'currentMonthNonAuthoritativeLedgerCount': value['currentMonthNonAuthoritativeLedgerCount'],
        'previousMonthNonAuthoritativeLedgerCount': value['previousMonthNonAuthoritativeLedgerCount'],
        'missingCzkConversionCount': value['missingCzkConversionCount'],
        'monthOverMonthChangePercentage': value['monthOverMonthChangePercentage'],
        'monthlyRecurringNetAmount': value['monthlyRecurringNetAmount'],
        'allCurrenciesConvertedToCzk': value['allCurrenciesConvertedToCzk'],
        'monthlyNetAmounts': value['monthlyNetAmounts'] == null ? undefined : ((value['monthlyNetAmounts'] as Array<any>).map(SubscriptionPaymentMonthlyStatsDataToJSON)),
    };
}

